import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { estaInstalada } from '../../utils/pwa';

/**
 * Acceso flotante para instalar la aplicación.
 *
 * Por qué flotante y no en el header: en un teléfono de 360px el header ya
 * lleva logo, buscador, región y usuario, y meter un quinto elemento aprieta
 * todo lo demás. Instalar además es una acción ocasional, no navegación.
 *
 * Va abajo a la izquierda porque «volver arriba» ocupa la derecha.
 *
 * Desaparece solo en dos casos:
 *   - Si la app ya está instalada. Ahí el acceso queda únicamente en el perfil,
 *     que es donde uno busca cómo sacarla.
 *   - Si el usuario lo descarta. Queda recordado: insistir con algo que ya
 *     rechazaron es la forma más rápida de que dejen de mirar esa esquina.
 */

const CLAVE_DESCARTADO = 'cholloman_instalar_descartado';

const yaSeDescarto = () => {
  try { return localStorage.getItem(CLAVE_DESCARTADO) === '1'; } catch { return false; }
};

const marcarDescartado = () => {
  try { localStorage.setItem(CLAVE_DESCARTADO, '1'); } catch { /* modo privado */ }
};

// Se muestra con un retraso: apareciendo junto con el contenido compite con lo
// que el usuario vino a ver.
const ESPERA_MS = 6000;

export const BotonInstalar = ({ onAbrir }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (estaInstalada() || yaSeDescarto()) return undefined;
    const t = setTimeout(() => setVisible(true), ESPERA_MS);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const descartar = (e) => {
    e.stopPropagation();
    marcarDescartado();
    setVisible(false);
  };

  return (
    <div
      id="boton-instalar"
      className="acceso-instalar"
    >
      <button
        id="boton-instalar-abrir"
        onClick={onAbrir}
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'none', border: 'none', color: '#fff',
          padding: '0 6px 0 16px', minHeight: 46,
          fontSize: '0.84rem', fontWeight: 700, cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        <Download size={16} style={{ color: '#FF4500' }} />
        Instalar app
      </button>

      <button
        id="boton-instalar-descartar"
        onClick={descartar}
        aria-label="No mostrar más"
        className="tap-exempt"
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)',
          cursor: 'pointer', width: 38, height: 46, borderRadius: 999,
        }}
      >
        <X size={15} />
      </button>
    </div>
  );
};
